"use client"

import { useQuery, type QueryClient } from "@tanstack/react-query"

import { usePermissions } from "@/hooks/use-permissions"
import { planFeatureAccessQueryPrefix } from "@/hooks/queries/plan-feature-access"
import { getActiveVoiceTrialAction, type ActiveVoiceTrialView } from "@/server-actions/voice-trial"

export const activeVoiceTrialQueryPrefix = ["voice-trial", "active"] as const

export function useActiveVoiceTrialQuery() {
  const { activeTenantId } = usePermissions()

  return useQuery<ActiveVoiceTrialView>({
    queryKey: [...activeVoiceTrialQueryPrefix, activeTenantId],
    enabled: Boolean(activeTenantId),
    queryFn: async () => {
      const result = await getActiveVoiceTrialAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}

/** A voice agent was created or deleted: the running trial and the Voice Agents lock may have changed. */
export function invalidateAfterVoiceAgentChange(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: activeVoiceTrialQueryPrefix }),
    queryClient.invalidateQueries({ queryKey: planFeatureAccessQueryPrefix }),
  ])
}
